<template>
  <div class="ai-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="container">
        <h1>AI人脸识别系统</h1>
        <p>智能身份验证解决方案</p>
      </div>
    </div>

    <!-- 核心功能 -->
    <section class="core-features">
      <div class="container">
        <div class="section-header text-center">
          <h2>四大核心功能</h2>
          <p>为您提供全方位的人脸识别解决方案</p>
        </div>
        <div class="row feature-grid">
          <div class="col-md-6">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/ai.f04e201c.gif" alt="电子名片">
              </div>
              <div class="feature-content">
                <h3>电子名片</h3>
                <p>智能识别访客身份，自动生成电子名片，实现高效访客管理。支持一键保存联系信息，方便后续跟进。</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/ai-mobile.dfcd3b51.gif" alt="精准维客">
              </div>
              <div class="feature-content">
                <h3>精准维客</h3>
                <p>通过人脸识别技术，精准识别老客户，提供个性化服务。记录客户来访频率，分析客户偏好，助力精准营销。</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/hemiao.aafbc56b.gif" alt="高效营销">
              </div>
              <div class="feature-content">
                <h3>高效营销</h3>
                <p>基于人脸识别分析客户画像，推送个性化营销信息。支持多渠道营销，提高转化率和客户满意度。</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="feature-card">
              <div class="feature-icon">
                <img src="../assets/images/banner.png" alt="轻松社交">
              </div>
              <div class="feature-content">
                <h3>轻松社交</h3>
                <p>提供智能社交功能，支持一键分享联系信息，促进业务交流。内置CRM系统，管理客户关系更高效。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 系统组成 -->
    <section class="system-components">
      <div class="container">
        <div class="section-header text-center">
          <h2>系统组成</h2>
          <p>完善的硬件和软件系统，确保稳定高效运行</p>
        </div>
        <div class="row">
          <div class="col-md-6 d-none d-md-block">
            <img 
              src="../assets/images/ai.f04e201c.gif" 
              alt="PC端系统" 
              class="system-img img-fluid"
            >
          </div>
          <div class="col-md-6">
            <div class="system-details">
              <h3>PC端管理系统</h3>
              <ul class="system-features">
                <li>用户管理：添加、编辑、删除用户，设置权限</li>
                <li>访客管理：查看访客记录，导出访客数据</li>
                <li>统计分析：客户画像分析，来访记录统计</li>
                <li>系统设置：个性化配置，硬件管理</li>
                <li>报表生成：自动生成各类数据报表</li>
              </ul>
              <button class="btn btn-primary demo-btn">申请演示</button>
            </div>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-6 order-2 order-md-1">
            <div class="system-details">
              <h3>移动端应用</h3>
              <ul class="system-features">
                <li>人脸识别：快速识别访客身份</li>
                <li>访客登记：一键登记新访客</li>
                <li>数据同步：与PC端实时数据同步</li>
                <li>消息推送：重要通知及时推送</li>
                <li>离线工作：支持离线模式下的基本功能</li>
              </ul>
              <button class="btn btn-primary demo-btn">申请演示</button>
            </div>
          </div>
          <div class="col-md-6 d-none d-md-block order-1 order-md-2">
            <img 
              src="../assets/images/ai-mobile.dfcd3b51.gif" 
              alt="移动端系统" 
              class="system-img img-fluid"
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 技术优势 -->
    <section class="tech-advantages">
      <div class="container">
        <div class="section-header text-center">
          <h2>技术优势</h2>
          <p>领先的人脸识别技术，确保高效准确</p>
        </div>
        <div class="row advantage-grid">
          <div class="col-md-4">
            <div class="advantage-card">
              <div class="advantage-number">01</div>
              <h3>高精度识别</h3>
              <p>采用深度学习算法，人脸识别准确率高达99.9%，即使在光线不佳的环境下也能保持稳定识别。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="advantage-card">
              <div class="advantage-number">02</div>
              <h3>快速响应</h3>
              <p>识别速度仅需0.3秒，实时响应，无需等待，提升用户体验。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="advantage-card">
              <div class="advantage-number">03</div>
              <h3>多场景支持</h3>
              <p>支持室内外多种场景，适应性强，可根据环境自动调整识别参数。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="advantage-card">
              <div class="advantage-number">04</div>
              <h3>安全加密</h3>
              <p>采用AES-256加密算法，保护用户数据安全，符合相关数据隐私法规。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="advantage-card">
              <div class="advantage-number">05</div>
              <h3>易于集成</h3>
              <p>提供标准API接口，易于与现有系统集成，降低实施成本。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="advantage-card">
              <div class="advantage-number">06</div>
              <h3>持续优化</h3>
              <p>通过大数据分析持续优化算法，识别能力不断提升。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 应用场景 -->
    <section class="application-scenes">
      <div class="container">
        <div class="section-header text-center">
          <h2>应用场景</h2>
          <p>广泛应用于各行各业，提供定制化解决方案</p>
        </div>
        <div class="row scene-grid">
          <div class="col-md-3">
            <div class="scene-card">
              <img 
                src="../assets/images/hongyun.7412facc.gif" 
                alt="企业门禁" 
                class="scene-img img-fluid"
              >
              <h3>企业门禁</h3>
              <p>员工快速通行，访客智能登记，提升企业安全管理水平</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="scene-card">
              <img 
                src="../assets/images/hemiao.aafbc56b.gif" 
                alt="智慧零售" 
                class="scene-img img-fluid"
              >
              <h3>智慧零售</h3>
              <p>客户分析，精准营销，提升购物体验和销售转化率</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="scene-card">
              <img 
                src="../assets/images/exp.595da4b7.gif" 
                alt="金融服务" 
                class="scene-img img-fluid"
              >
              <h3>金融服务</h3>
              <p>身份验证，反欺诈，提高金融交易安全性</p>
            </div>
          </div>
          <div class="col-md-3">
            <div class="scene-card">
              <img 
                src="../assets/images/banner.png" 
                alt="教育机构" 
                class="scene-img img-fluid"
              >
              <h3>教育机构</h3>
              <p>学生考勤，校园安全，提高学校管理效率</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户评价 -->
    <section class="customer-reviews">
      <div class="container">
        <div class="section-header text-center">
          <h2>客户评价</h2>
          <p>来自各行各业的客户真实反馈</p>
        </div>
        <div class="row review-grid">
          <div class="col-md-4">
            <div class="review-card">
              <div class="reviewer-info">
                <img 
                src="../assets/images/1.670c7eef.gif" 
                alt="客户头像" 
                class="reviewer-avatar"
              >
                <div class="reviewer-details">
                  <h4>张经理</h4>
                  <p>某科技公司</p>
                </div>
              </div>
              <div class="review-content">
                <p>"禾苗AI人脸识别系统大大提升了我们公司的门禁管理效率，员工通行速度明显提升，访客登记更加便捷。系统稳定可靠，推荐使用！"</p>
              </div>
              <div class="review-rating">
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="review-card">
              <div class="reviewer-info">
                <img 
                src="../assets/images/2.0a9650a7.gif" 
                alt="客户头像" 
                class="reviewer-avatar"
              >
                <div class="reviewer-details">
                  <h4>李总</h4>
                  <p>某零售企业</p>
                </div>
              </div>
              <div class="review-content">
                <p>"使用禾苗AI系统后，我们能够精准识别客户，提供个性化服务，销售额提升了20%。数据分析功能也很强大，帮助我们更好地了解客户需求。"</p>
              </div>
              <div class="review-rating">
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="review-card">
              <div class="reviewer-info">
                <img 
                src="../assets/images/banner.png" 
                alt="客户头像" 
                class="reviewer-avatar"
              >
                <div class="reviewer-details">
                  <h4>王校长</h4>
                  <p>某教育机构</p>
                </div>
              </div>
              <div class="review-content">
                <p>"禾苗的人脸识别系统在我们学校得到了广泛应用，学生考勤变得轻松高效，家长也能实时了解孩子的到校情况，非常方便！"</p>
              </div>
              <div class="review-rating">
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star active"></i>
                <i class="iconfont icon-star-half"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-us">
      <div class="container">
        <div class="section-header text-center">
          <h2>联系我们</h2>
          <p>如需了解更多产品信息，欢迎随时联系我们</p>
        </div>
        <div class="contact-form">
          <div class="row">
            <div class="col-md-6">
              <form @submit.prevent="handleSubmit">
                <div class="form-group">
                  <label for="name">姓名</label>
                  <input type="text" class="form-control" id="name" v-model="formData.name" required>
                </div>
                <div class="form-group">
                  <label for="phone">电话</label>
                  <input type="tel" class="form-control" id="phone" v-model="formData.phone" required>
                </div>
                <div class="form-group">
                  <label for="company">公司名称</label>
                  <input type="text" class="form-control" id="company" v-model="formData.company" required>
                </div>
                <div class="form-group">
                  <label for="message">留言内容</label>
                  <textarea class="form-control" id="message" rows="4" v-model="formData.message" required></textarea>
                </div>
                <button type="submit" class="btn btn-primary submit-btn">提交</button>
              </form>
            </div>
            <div class="col-md-6">
              <div class="contact-info">
                <h3>联系方式</h3>
                <ul class="info-list">
                  <li>
                    <i class="iconfont icon-phone"></i>
                    <span>咨询电话：153 9285 0129</span>
                  </li>
                  <li>
                    <i class="iconfont icon-mail"></i>
                    <span>企业邮箱：service2@hemiao100.com</span>
                  </li>
                  <li>
                    <i class="iconfont icon-location"></i>
                    <span>公司地址：湖北省武汉市江汉区淮海路中央商务区泛海国际SOHO城8栋8层</span>
                  </li>
                </ul>
                <div class="working-hours">
                  <h4>工作时间</h4>
                  <p>周一至周五：9:00 - 18:00</p>
                  <p>周六至周日：10:00 - 16:00</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Ai',
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        company: '',
        message: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      // 这里可以添加表单提交逻辑
      console.log('表单提交：', this.formData)
      alert('感谢您的留言，我们将尽快与您联系！')
      // 重置表单
      this.formData = {
        name: '',
        phone: '',
        company: '',
        message: ''
      }
    }
  }
}
</script>

<style scoped>
.ai-page {
  min-height: 100vh;
}

/* 页面标题 */
.page-header {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  padding: 5rem 0;
  text-align: center;
}

.page-header h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.page-header p {
  font-size: 1.5rem;
  opacity: 0.9;
}

/* 核心功能 */
.core-features {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.section-header {
  margin-bottom: 3rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.section-header h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #007bff;
}

.section-header p {
  font-size: 1.2rem;
  color: #666;
  margin-top: 1.5rem;
}

.feature-card {
  display: flex;
  align-items: flex-start;
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  margin-right: 1.5rem;
  flex-shrink: 0;
}

.feature-icon img {
  width: 80px;
  height: 80px;
}

.feature-content h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.feature-content p {
  color: #666;
  line-height: 1.6;
}

/* 系统组成 */
.system-components {
  padding: 5rem 0;
}

.system-img {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.system-details {
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.system-details h3 {
  font-size: 2rem;
  color: #333;
  margin-bottom: 1.5rem;
}

.system-features {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.system-features li {
  padding: 0.8rem 0;
  border-bottom: 1px solid #e9ecef;
  position: relative;
  padding-left: 1.5rem;
}

.system-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #007bff;
  font-weight: bold;
}

.demo-btn {
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  border-radius: 4px;
}

/* 技术优势 */
.tech-advantages {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.advantage-grid {
  margin: 0 -15px;
}

.advantage-card {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.advantage-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.advantage-number {
  position: absolute;
  top: 1rem;
  right: 1rem;
  font-size: 3rem;
  color: #007bff;
  opacity: 0.1;
  font-weight: bold;
}

.advantage-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.advantage-card p {
  color: #666;
  line-height: 1.6;
}

/* 应用场景 */
.application-scenes {
  padding: 5rem 0;
}

.scene-grid {
  margin: 0 -15px;
}

.scene-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 100%;
}

.scene-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.scene-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.scene-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin: 1.5rem;
}

.scene-card p {
  color: #666;
  margin: 0 1.5rem 1.5rem;
  line-height: 1.6;
}

/* 客户评价 */
.customer-reviews {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.review-grid {
  margin: 0 -15px;
}

.review-card {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.review-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.reviewer-info {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.reviewer-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 1rem;
}

.reviewer-details h4 {
  font-size: 1.2rem;
  color: #333;
  margin: 0;
}

.reviewer-details p {
  color: #666;
  margin: 0.25rem 0 0;
}

.review-content p {
  color: #666;
  line-height: 1.8;
  font-style: italic;
  margin-bottom: 1.5rem;
}

.review-rating {
  color: #ddd;
  font-size: 1.2rem;
}

.review-rating .active {
  color: #ffc107;
}

/* 联系我们 */
.contact-us {
  padding: 5rem 0;
}

.contact-form {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  font-weight: 500;
  color: #333;
  margin-bottom: 0.5rem;
}

.form-control {
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 0.75rem;
  width: 100%;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  outline: none;
}

.submit-btn {
  padding: 0.75rem 2rem;
  font-size: 1.1rem;
  border-radius: 4px;
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  width: 100%;
}

.submit-btn:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.contact-info h3 {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 2rem;
}

.info-list {
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
}

.info-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.info-list li i {
  font-size: 1.5rem;
  color: #007bff;
  margin-right: 1rem;
}

.info-list li span {
  color: #666;
  line-height: 1.6;
}

.working-hours h4 {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 1rem;
}

.working-hours p {
  color: #666;
  margin-bottom: 0.5rem;
}

/* 响应式设计 */
@media (max-width: 767px) {
  .page-header h1 {
    font-size: 2.5rem;
  }
  
  .page-header p {
    font-size: 1.2rem;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .section-header p {
    font-size: 1rem;
  }
  
  .feature-card {
    flex-direction: column;
    text-align: center;
  }
  
  .feature-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  
  .system-img {
    margin-bottom: 2rem;
  }
  
  .scene-img {
    height: 150px;
  }
}

@media (max-width: 575px) {
  .page-header {
    padding: 3rem 0;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .core-features,
  .system-components,
  .tech-advantages,
  .application-scenes,
  .customer-reviews,
  .contact-us {
    padding: 3rem 0;
  }
  
  .advantage-card,
  .scene-card,
  .review-card {
    margin-bottom: 1.5rem;
  }
}
</style>